import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/MDXPageLayout.js";
import HackavizContest from '../../components/HackavizContest';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



<HackavizContest startDate={new Date('2026-03-25')} endDate={new Date('2026-04-06')} tallyFormUrl={'toulouse-dataviz.notion.site/30cc08a98edb81fdac47ef3bc45a060f'} partyDate={new Date('2026-04-16')} extraMessage="" customDataButtons={[{
      url: 'https://github.com/Toulouse-Dataviz/hackaviz-2026',
      buttonLabel: 'Lire la description'
    }, {
      url: 'https://github.com/Toulouse-Dataviz/hackaviz-2026/releases',
      buttonLabel: 'Télécharger les données'
    }, {
      url: 'https://toulouse-dataviz.notion.site/335c08a98edb8137b061c219392c306d',
      buttonLabel: 'Soumettre votre réalisation'
    }]} mdxType="HackavizContest" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      